export default {
  LOAD_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_PAGE_START: 'LoadStudyPlanCycleStudentOverviewPageStart',
  LOAD_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_PAGE_END: 'LoadStudyPlanCycleStudentOverviewPageEnd',
  TOGGLE_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_CONFIRM_DIALOG: 'ToggleStudyPlanCycleStudentOverviewConfirmDialog',
  TOGGLE_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_ACCREDITMENT_FORM: 'ToggleStudyPlanCycleStudentOverviewAccreditmentForm',
  ACCREDIT_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_START: 'AccreditStudyPlanCycleStudentOverviewStart',
  ACCREDIT_STUDY_PLAN_CYCLE_STUDENT_OVERVIEW_END: 'AccreditStudyPlanCycleStudentOverviewEnd'
};